export default function InternalLinks() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-10">
          Vous cherchez aussi...
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          <a
            href="/"
            className="group block bg-white rounded-2xl border border-rose-100 p-5 md:p-6 hover:border-coral/40 transition-colors"
          >
            <h3 className="font-serif text-base md:text-lg font-semibold text-plum-dark mb-2">
              Accueil
            </h3>
            <p className="text-plum-dark text-sm leading-relaxed mb-3">
              Découvrez tous nos services de réparation de fenêtre dans le Bas-Rhin.
            </p>
            <span className="inline-flex items-center gap-1 text-coral text-sm font-medium">
              Visiter
              <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
            </span>
          </a>
          <a
            href="/nos-prestations"
            className="group block bg-white rounded-2xl border border-rose-100 p-5 md:p-6 hover:border-coral/40 transition-colors"
          >
            <h3 className="font-serif text-base md:text-lg font-semibold text-plum-dark mb-2">
              Nos prestations
            </h3>
            <p className="text-plum-dark text-sm leading-relaxed mb-3">
              Voir la liste complète de nos interventions : oscillo-battant, crémone, poignée, gond...
            </p>
            <span className="inline-flex items-center gap-1 text-coral text-sm font-medium">
              Découvrir
              <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
            </span>
          </a>
          <a
            href="/reparation-fenetre-illkirch-graffenstaden"
            className="group block bg-white rounded-2xl border border-rose-100 p-5 md:p-6 hover:border-coral/40 transition-colors"
          >
            <h3 className="font-serif text-base md:text-lg font-semibold text-plum-dark mb-2">
              Réparation Illkirch-Graffenstaden
            </h3>
            <p className="text-plum-dark text-sm leading-relaxed mb-3">
              Fenêtre qui ferme mal à Illkirch ? Nos techniciens interviennent dans le sud de l'agglomération strasbourgeoise.
            </p>
            <span className="inline-flex items-center gap-1 text-coral text-sm font-medium">
              Voir
              <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}